import React, { useState } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { setTheActiveEmployeeCreatesList } from "../../../Redux/Slice";
import { useDispatch, useSelector } from "react-redux";
const ActiveEmployeeCreate = (props) => {
  const { setShow, show, UserID, ActiveFor , setTogleActive ,callretrieve } = props;
  const dispatch = useDispatch();
  const initialState = {
    notes: "",
    user_id: UserID,
    status: "approved",
    request_type: ActiveFor == 1 ? "request" : "cancel",
  };
   console.log(ActiveFor ,"ActiveFor");
  const [Data, setDatas] = useState(initialState);
  const [Notersrr, setNotesErr] = useState();
  const HandleChanges = (e) => {
    setDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };
  const HandleSubmit = (e) => {
    var a = 0;
    if (Data.notes == "") {
      setNotesErr("*Notes is required");
      a = 1;
    }
    if (a == 0) {
      dispatch(setTheActiveEmployeeCreatesList(Data, props.setShow(false) , ActiveFor == 1 ? setTogleActive(true) :  setTogleActive(false)  ));
    }
  };
  return (
    <>
      <div className="Shift RoleCreatePopup">
        <div className="Shift ShiftCreatePopup">
          <div className="  BeforeSHIFTPopUp">
            <div className=" BodyShiftContent" style={{width:"29%"}}>
              <div className="card">
                <div className="card-body cards ">
                  <div className="UserPoup">
                    <div className="BeforForms">
                      <div className="Form">
                        <div className="ModalHeader">
                          {ActiveFor == 1 ? (
                            <span>Active Apply</span>
                          ) : (
                            <span>InActive Apply</span>
                          )}

                          <div
                            className="CloseIcon"
                            onClick={(e) => setShow(false)}
                          >
                            <CloseOutlinedIcon />
                          </div>
                        </div>
                        <div className="Modal-Body">
                          <div className="row">
                            <div className="col mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Notes
                              </label>
                              <span style={{ color: "red" }}>*</span>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="notes"
                                value={Data.notes}
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setNotesErr("");
                                }}
                              />
                              <p className="Error">{Notersrr}</p>
                            </div>
                          </div>
                        </div>

                        <div
                          className="RoleButton"
                          style={{
                            display: "flex",
                            gap: "15px",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <button
                            class="btn  SaveBtn"
                            type="submit"
                            onClick={(e) => {
                              HandleSubmit(e);
                            }}
                          >
                            Submit 
                          </button>

                          <button
                            class="btn CancelBtn"
                            onClick={(e) => setShow(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActiveEmployeeCreate;
